
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.594 2.906H1.406C.631 2.906 0 3.537 0 4.312v9.375c0 .776.63 1.407 1.406 1.407h13.188c.775 0 1.406-.631 1.406-1.406V4.312c0-.775-.63-1.406-1.406-1.406zm.469 10.781a.47.47 0 01-.47.47H1.407a.47.47 0 01-.468-.47V4.313a.47.47 0 01.468-.47h13.188a.47.47 0 01.469.47v9.375z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6.924 6.281h-4.66a.388.388 0 00-.389.389v4.66c0 .215.174.389.388.389h4.661a.388.388 0 00.388-.389V6.67a.388.388 0 00-.388-.389zm-.388.777v3.667H2.652V7.058h3.884zM13.658 6.625H9.845a.469.469 0 000 .938h3.813a.469.469 0 000-.938zM13.658 8.5H9.845a.469.469 0 000 .938h3.813a.469.469 0 000-.938zM13.658 10.375H9.845a.469.469 0 000 .938h3.813a.469.469 0 000-.938z","fill":"currentColor"}})])
          )
        }
      }
    